import { default as normalDistributionFunctions } from './normal';
import { default as fisherDistributionFunctions } from './fisher';
import { default as studentDistributionFunctions } from './student';
import { default as binomialDistributionFunctions } from './binomial';
import { default as chisquareDistributionFunctions } from './chisquare';

const distributionsFunctions = {
  normal: normalDistributionFunctions,
  fisher: fisherDistributionFunctions,
  student: studentDistributionFunctions,
  binomial: binomialDistributionFunctions,
  chisquare: chisquareDistributionFunctions
};

const getDistributionFunctionsByType = distributionType =>
  distributionsFunctions[distributionType];

export const getMinLeftCutoff = distributionFormValues => {
  return getDistributionFunctionsByType(distributionFormValues.type)
    // we need to set the minimum values to 0.00000005, because when we have both tails, alpha is divided by two
    // therefore we need to take alpha half as much as 0.00001
    .getCutoffsByAlpha(distributionFormValues, 0.00000005).left.x;
};

export const getMaxLeftCutoff = distributionFormValues =>
  getDistributionFunctionsByType(distributionFormValues.type)
    .getCutoffsByAlpha(distributionFormValues, 0.9999999).left.x;

export const getMinRightCutoff = distributionFormValues =>
  getDistributionFunctionsByType(distributionFormValues.type)
    .getCutoffsByAlpha(distributionFormValues, 0.9999999).right.x;

export const getMaxRightCutoff = distributionFormValues =>
  getDistributionFunctionsByType(distributionFormValues.type)
  // we need to set the minimum values to 0.00000005, because when we have both tails, alpha is divided by two
  // therefore we need to take alpha half as much as 0.00001
    .getCutoffsByAlpha(distributionFormValues, 0.00000005).right.x;

export default getDistributionFunctionsByType;
